import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

export default function ItineraryModal({
  open,
  onClose,
  images,
  startIndex = 0,
  baseUrl,
}) {
  const [activeIndex, setActiveIndex] = useState(startIndex);

  // ✅ Update when modal opens or index changes
  useEffect(() => {
    if (open) {
      setActiveIndex(startIndex);
    }
  }, [startIndex, open]);

  if (!open || !images?.length) return null;

  return (
    <div className="itinerary-overlay multiimages_prd">
      <div className="thumbs-container">
        {images.map((item, i) => (
          <div
            key={i}
            className={`thumb-item ${activeIndex === i ? "active" : ""}`}
            onClick={() => setActiveIndex(i)}
          >
            <img src={`${baseUrl}${item.image}`} alt={item.activity_title} />
          </div>
        ))}
      </div>

      <div className="itinerary-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>

        <div className="itinerary-layout">
          {/* Thumbnails */}

          {/* Main Image */}
          <div className="main-image-container">
            <img
              src={`${baseUrl}${images[activeIndex]?.image}`}
              alt={images[activeIndex]?.activity_title}
              className="main-image"
            />
          </div>

          {/* Right Content */}
          <div className="info-content">
            <h3>
              {images[activeIndex]?.place ||
                "Check in, meet your instructor, and get a quick safety briefing."}
            </h3>
            <p>{images[activeIndex]?.activity_title || "Itinerary Detail"}</p>
            {/* <p>
              {images[activeIndex]?.place ||
                "Check in, meet your instructor, and get a quick safety briefing."}
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}
